export default "__VITE_ASSET__BUg1$keA__"